module.exports = __webpack_public_path__ + "static/img/fuselage_603K.f71d51a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/products/fuselage_603K.jpg
// module id = TKoV
// module chunks = 0